import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * Onay penceresi.
 *
 * Native window.confirm() yerine kullanılır: tarayıcının kendi diyaloğu tüm
 * sayfayı bloke eder ve stil verilemez.
 *
 * `extra` ile onay öncesi ek bir seçenek (checkbox vb.) gösterilebilir.
 */
const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  extra = null,
  confirmLabel = 'Onayla',
  cancelLabel = 'Vazgeç',
  destructive = false,
  onConfirm,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && (
          <AlertDialogDescription className="whitespace-pre-line">
            {description}
          </AlertDialogDescription>
        )}
      </AlertDialogHeader>

      {extra && <div className="py-2">{extra}</div>}

      <AlertDialogFooter>
        <AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className={destructive ? 'bg-red-600 hover:bg-red-700 text-white' : undefined}
        >
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDialog;
